// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var RedirectionUrl$ReactHooksTemplate = require("./redirectionUrl.res.js");
var TicketCategory$ReactHooksTemplate = require("../tickets/ticketCategory.res.js");

function targetTypeFromString(target) {
  switch (target) {
    case "Question" :
        return "QuestionTarget";
    case "RedirectionUrl" :
        return "RedirectionUrlTarget";
    case "ThankYou" :
        return "ThankYouTarget";
    case "TicketCategory" :
        return "TicketCategoryTarget";
    default:
      return "None";
  }
}

function id(t) {
  return t.id;
}

function actionType(t) {
  return t.actionType;
}

function setActionType(t, actionType) {
  return {
          id: t.id,
          actionType: actionType
        };
}

function emptyAction(target) {
  return {
          id: undefined,
          actionType: {
            TAG: "Jump",
            _0: target
          }
        };
}

function emptySkipAction(target) {
  return {
          id: undefined,
          actionType: {
            TAG: "Skip",
            _0: target
          }
        };
}

function emptyRedirectionAction(target) {
  return {
          id: undefined,
          actionType: {
            TAG: "Redirection",
            _0: target
          }
        };
}

function emptyTicketGenerationAction(target) {
  return {
          id: undefined,
          actionType: {
            TAG: "TicketGeneration",
            _0: target
          }
        };
}

function decodeJumpTarget(json, questions, thankYouList) {
  var targetType = Json_decode.field("target_type", Json_decode.string, json);
  var targetId = List.hd(Json_decode.field("target_ids", (function (param) {
              return Json_decode.list(Json_decode.$$int, param);
            }), json));
  var match = targetTypeFromString(targetType);
  switch (match) {
    case "QuestionTarget" :
        return {
                TAG: "Question",
                _0: List.find((function (x) {
                        return Belt_Option.getExn(Question$ReactHooksTemplate.id(x)) === targetId;
                      }), questions)
              };
    case "ThankYouTarget" :
        return {
                TAG: "ThankYou",
                _0: List.find((function (x) {
                        return Belt_Option.getExn(ThankYou$ReactHooksTemplate.id(x)) === targetId;
                      }), thankYouList)
              };
    default:
      return Js_exn.raiseError("Unknown Jump type");
  }
}

function decodeRedirectionTarget(json, redirectionUrls) {
  var targetType = Json_decode.field("target_type", Json_decode.string, json);
  var targetId = List.hd(Json_decode.field("target_ids", (function (param) {
              return Json_decode.list(Json_decode.$$int, param);
            }), json));
  var match = targetTypeFromString(targetType);
  if (match === "RedirectionUrlTarget") {
    return List.find((function (x) {
                  return Belt_Option.getExn(RedirectionUrl$ReactHooksTemplate.id(x)) === targetId;
                }), redirectionUrls);
  } else {
    return Js_exn.raiseError("Unknown Redirection type");
  }
}

function decodeTicketGenerationTarget(json, ticketCategory) {
  var targetType = Json_decode.field("target_type", Json_decode.string, json);
  var targetId = List.hd(Json_decode.field("target_ids", (function (param) {
              return Json_decode.list(Json_decode.$$int, param);
            }), json));
  var match = targetTypeFromString(targetType);
  if (match === "TicketCategoryTarget") {
    return List.find((function (x) {
                  return Belt_Option.getExn(TicketCategory$ReactHooksTemplate.id(x)) === targetId;
                }), ticketCategory);
  } else {
    return Js_exn.raiseError("Unknown Ticket generation type");
  }
}

function decodeSkipTarget(json, questions, thankYouList) {
  var targetType = Json_decode.field("target_type", Json_decode.string, json);
  var targetIds = Json_decode.field("target_ids", (function (param) {
          return Json_decode.list(Json_decode.$$int, param);
        }), json);
  var match = targetTypeFromString(targetType);
  switch (match) {
    case "QuestionTarget" :
        var skipQuestions = List.map((function (x) {
                return List.find((function (y) {
                              return Belt_Option.getExn(Question$ReactHooksTemplate.id(y)) === x;
                            }), questions);
              }), targetIds);
        return {
                TAG: "Questions",
                _0: skipQuestions
              };
    case "ThankYouTarget" :
        var skipThankYous = List.map((function (x) {
                return List.find((function (y) {
                              return Belt_Option.getExn(ThankYou$ReactHooksTemplate.id(y)) === x;
                            }), thankYouList);
              }), targetIds);
        return {
                TAG: "ThankYous",
                _0: skipThankYous
              };
    default:
      return Js_exn.raiseError("Unknown Skip type");
  }
}

function decodeActionType(json, questions, thankYouList, redirectionUrls, ticketCategories) {
  var actionType = Json_decode.field("action_type", Json_decode.string, json);
  switch (actionType) {
    case "jump" :
        return {
                TAG: "Jump",
                _0: decodeJumpTarget(json, questions, thankYouList)
              };
    case "redirection" :
        return {
                TAG: "Redirection",
                _0: decodeRedirectionTarget(json, redirectionUrls)
              };
    case "skip" :
        return {
                TAG: "Skip",
                _0: decodeSkipTarget(json, questions, thankYouList)
              };
    case "ticket_generation" :
        return {
                TAG: "TicketGeneration",
                _0: decodeTicketGenerationTarget(json, ticketCategories)
              };
    default:
      return Js_exn.raiseError("Unknown action type");
  }
}

function decode(json, questions, thankYouList, redirectionUrls, ticketCategories) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          actionType: decodeActionType(json, questions, thankYouList, redirectionUrls, ticketCategories)
        };
}

function skipTargetIds(x) {
  var match = x.actionType;
  if (match.TAG !== "Skip") {
    return /* [] */0;
  }
  var y = match._0;
  if (y.TAG === "Questions") {
    return Belt_List.map(y._0, (function (xs) {
                  return Belt_Option.getExn(Question$ReactHooksTemplate.id(xs));
                }));
  } else {
    return Belt_List.map(y._0, (function (xs) {
                  return Belt_Option.getExn(ThankYou$ReactHooksTemplate.id(xs));
                }));
  }
}

function skipActionId(t) {
  var match = t.actionType;
  if (match.TAG === "Skip") {
    return t.id;
  }
  
}

function stringOfActionType(t) {
  var match = t.actionType;
  switch (match.TAG) {
    case "Skip" :
        return "skip";
    case "Jump" :
        return "jump";
    case "Redirection" :
        return "redirection";
    case "TicketGeneration" :
        return "ticket generation";
    
  }
}

function stringOfSkipTargetType(t) {
  var match = t.actionType;
  if (match.TAG === "Skip") {
    if (match._0.TAG === "Questions") {
      return "Question";
    } else {
      return "ThankYou";
    }
  } else {
    return "";
  }
}

function stringOfJumpTargetType(t) {
  var match = t.actionType;
  if (match.TAG === "Jump") {
    if (match._0.TAG === "Question") {
      return "Question";
    } else {
      return "ThankYou";
    }
  } else {
    return "";
  }
}

function jumpTargetIds(t) {
  var match = t.actionType;
  if (match.TAG !== "Jump") {
    return /* [] */0;
  }
  var y = match._0;
  if (y.TAG === "Question") {
    return {
            hd: Belt_Option.getExn(Question$ReactHooksTemplate.id(y._0)),
            tl: /* [] */0
          };
  } else {
    return {
            hd: Belt_Option.getExn(ThankYou$ReactHooksTemplate.id(y._0)),
            tl: /* [] */0
          };
  }
}

function redirectionTargetIds(t) {
  var y = t.actionType;
  if (y.TAG === "Redirection") {
    return {
            hd: Belt_Option.getExn(RedirectionUrl$ReactHooksTemplate.id(Belt_Option.getExn(y._0))),
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

function ticketCategoryTargetIds(t) {
  var y = t.actionType;
  if (y.TAG === "TicketGeneration") {
    return {
            hd: Belt_Option.getExn(TicketCategory$ReactHooksTemplate.id(Belt_Option.getExn(y._0))),
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

function skipActionToJson(destroyOpt, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  var targetIds = skipTargetIds(t);
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), skipActionId(t))
              ],
              tl: {
                hd: [
                  "target_type",
                  stringOfSkipTargetType(t)
                ],
                tl: {
                  hd: [
                    "target_ids",
                    Belt_List.toArray(Belt_List.map(targetIds, (function (x) {
                                return x;
                              })))
                  ],
                  tl: {
                    hd: [
                      "_destroy",
                      destroy
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function jumpActionToJson(destroyOpt, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  var targetIds = jumpTargetIds(t);
  return Json_encode.object_({
              hd: [
                "target_type",
                stringOfJumpTargetType(t)
              ],
              tl: {
                hd: [
                  "target_ids",
                  Belt_List.toArray(Belt_List.map(targetIds, (function (x) {
                              return x;
                            })))
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function redirectionActionToJson(destroyOpt, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  var targetIds = redirectionTargetIds(t);
  return Json_encode.object_({
              hd: [
                "target_type",
                "RedirectionUrl"
              ],
              tl: {
                hd: [
                  "target_ids",
                  Belt_List.toArray(Belt_List.map(targetIds, (function (x) {
                              return x;
                            })))
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function ticketGenerationActionToJson(destroyOpt, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  var targetIds = ticketCategoryTargetIds(t);
  return Json_encode.object_({
              hd: [
                "target_type",
                "TicketCategory"
              ],
              tl: {
                hd: [
                  "target_ids",
                  Belt_List.toArray(Belt_List.map(targetIds, (function (x) {
                              return x;
                            })))
                ],
                tl: {
                  hd: [
                    "_destroy",
                    destroy
                  ],
                  tl: /* [] */0
                }
              }
            });
}

var actions = {
  hd: "Jump",
  tl: {
    hd: "Skip",
    tl: {
      hd: "Redirection",
      tl: {
        hd: "Ticket Generation",
        tl: /* [] */0
      }
    }
  }
};

exports.actions = actions;
exports.id = id;
exports.actionType = actionType;
exports.setActionType = setActionType;
exports.emptyAction = emptyAction;
exports.emptySkipAction = emptySkipAction;
exports.emptyRedirectionAction = emptyRedirectionAction;
exports.emptyTicketGenerationAction = emptyTicketGenerationAction;
exports.stringOfActionType = stringOfActionType;
exports.decode = decode;
exports.skipActionToJson = skipActionToJson;
exports.jumpActionToJson = jumpActionToJson;
exports.redirectionActionToJson = redirectionActionToJson;
exports.ticketGenerationActionToJson = ticketGenerationActionToJson;
/* Question-ReactHooksTemplate Not a pure module */
